// extracted by mini-css-extract-plugin
module.exports = {"main":"BBPicture_main__2R5-v","list":"BBPicture_list__2_xO6","firstItemBold":"BBPicture_firstItemBold__25xU4","link":"BBPicture_link__1GMZS"};